import React from 'react';

import useTranslation from '../../../hooks/use_translation';
import Link from '../link';
import './buttons.scss'

const JumpToContentButton = () => {
	const { t } = useTranslation('component_jump_to_content_button');

	return (
		<>
			<div className='jump_to_content_button'>
				<Link aria-label={t('t1')} className="btn btn-lg btn-danger text-white" to="#content" >{t('t1')}</Link>
			</div>
		</>
	);
};


export default JumpToContentButton;
